class PurchaseOrderTableController extends BaseController
	autoScopeInject: false

	@register angular.module 'App.Module.Controller'
	@inject 'MessageTerminal',
		'ToggleAllService'
		'PurchaseOrderFormatService'
		'ConfigurationService'

	initialize: ->
		@filter ?= {}
		@isLocked ?= false
		@productsList ?= null
		@events = @MessageTerminal.events.PURCHASE_ORDER
		@isAllProductsSelected = true
		@isCostPriceRecalculationEnabled = @ConfigurationService.isEnabled(
			'Backoffice.Setting.RecalculateCostPriceOnPurchaseOrder.Enabled'
		)
		@pager = new TableService(0)

		@ToggleAllService.items = @productsList

		@initListeners()

		if not _.isEmpty @productsList
			@processData()

	initListeners: ->
		@MessageTerminal.on @$scope, @events.ADD_ITEM, (newProducts, isManuallyAdded) =>
			@addProductsToList newProducts, isManuallyAdded

		@MessageTerminal.on @$scope, @events.REPORT_DATA, (data) =>
			@productsList = data

			@processData()
			@MessageTerminal.publish @events.TABLE_RELOAD, @productsList
			@ToggleAllService.items = @productsList

			@sortReport 'product_name', 'ASC'

	sortReport: (property, direction = null) ->
		direction = @handleSortDirection(property, direction)

		@filter.sort.property = property

		# Complicated sorting to solve the following problems:
		# 1. Sorting by nested object
		# 2. Numeric strings natural sorting
		# 3. Case-insensitive string sorting
		# 4. Stable sorting (list completely does not change if property is equal on all objects in the list)

		# these properties will be cast to numbers when sorting
		numericComparisonProperties = ['quantity', 'min_quantity', 'average_per_day', 'suggested_restock']

		@productsList.sort (a, b) =>
			valueA = a[0][property]
			valueB = b[0][property]

			if numericComparisonProperties.includes property
				# "+value" needed to cast string to number
				comparison = (+valueA) - (+valueB)
			else
				comparison = valueA.localeCompare(valueB, undefined , {numeric: true, sensitivity: 'base'})

			if @filter.sort.direction == 'DESC'
				comparison *= -1

			return comparison

	handleSortDirection: (property, direction = null) ->
		if direction == null
			if @filter.sort.property == property && @filter.sort.direction == 'DESC'
				direction = 'ASC'
			else
				direction = 'DESC'

		@filter.sort.direction = direction

		return direction

	##
	# Immediately removes a single product/variant row from the table and marks it
	# for deletion on the next save, instead of relying on an "unchecked" checkbox.
	##
	removeProduct: (product, products) ->
		return if @isLocked

		product.selected = false
		product.dirty = true

		# `product` is a report-row object created by PurchaseOrderFormatService.convertLineItemToReport(),
		# not the same object reference as the backing purchaseOrder.line_items entry. Once this row is
		# spliced out of productsList below, PurchaseOrderDirectiveController.onProductsListChange() will no
		# longer see it, so it can never sync `selected`/`dirty` back onto the real line item. Update the
		# backing line item directly here so the deletion is still picked up by save().
		backingLineItem = _.find(
			@purchaseOrder?.line_items,
			{
				product_id: product.product_id
				product_variant_id: product.product_variant_id
			}
		)

		if backingLineItem?
			backingLineItem.selected = false
			backingLineItem.dirty = true

		index = products.indexOf product
		products.splice(index, 1) if index != -1

		remainingProducts = _.reject products, {virtual: true}

		if remainingProducts.length == 0
			groupIndex = @productsList.indexOf products
			@productsList.splice(groupIndex, 1) if groupIndex != -1
			@pager.count = @productsList.length
			lastPage = Math.max(1, Math.ceil(@pager.count / @pager.pageSize))
			@pager.setPage(lastPage) if @pager.page > lastPage
		else
			virtualProduct = _.find products, {virtual: true}

			if virtualProduct?
				virtualProduct.min_quantity = @getColumnSum(remainingProducts, 'min_quantity')
				virtualProduct.quantity = @getColumnSum(remainingProducts, 'quantity')
				virtualProduct.average_per_day = @getColumnSum(remainingProducts, 'average_per_day')
				virtualProduct.suggested_restock = @getColumnSum(remainingProducts, 'suggested_restock')

		@ToggleAllService.items = @productsList
		@ToggleAllService.setGlobalToggleAll()

	getColumnSum: (products, column) ->
		_.reduce(
			products,
			(memo, product) ->
				memo + parseFloat(if not product.virtual then product[column] or 0 else 0)
		,
			0
		)

	getVirtualProduct: (otherProducts, isManuallyAdded = false) ->
		return {
			virtual: true
			manual: isManuallyAdded
			selected: true
			cost_price: null
			actual_cost_price: null
			product_id: otherProducts[0].product_id
			product_name: otherProducts[0].product_name
			unit_id: otherProducts[0].unit_id
			product_variant_id: null
			quantity: @getColumnSum(otherProducts, 'quantity')
			min_quantity: @getColumnSum(otherProducts, 'min_quantity')
			average_per_day: @getColumnSum(otherProducts, 'average_per_day')
			suggested_restock: @getColumnSum(otherProducts, 'suggested_restock')
			product_supplier_name: otherProducts[0].product_supplier_name
			product_supplier_id: otherProducts[0].product_supplier_id
			product_variant_supplier_id: null
			product_variant_supplier_name: null
		}

	##
	# Extract product information from variants
	# Some values may be missing main product - sold only variants
	##
	processData: ->
		@productsList ?= []
		@pager.count = @productsList.length

		for products in @productsList
			mainProduct = _.find products, {product_variant_id: null}

			for product in products
				product.product_supplier_name ?= _.find(@suppliers, {id: product.product_supplier_id})?.name
				product.product_variant_supplier_name ?= _.find(@suppliers, {id: product.product_variant_supplier_id})?.name
				product.selected = true
				product.requested_quantity ?= product.suggested_restock
				product.requested_quantity = parseFloat(product.requested_quantity)
				product.received_quantity = if product.received_quantity? then parseFloat(product.received_quantity) else product.requested_quantity

			if angular.isUndefined mainProduct
				mainProduct = @getVirtualProduct(products)
			else
				products = _.reject products, mainProduct

			products.unshift mainProduct

			@PurchaseOrderFormatService.convertQuantityTypes products

	addProductsToList: (newProductsList, isManuallyAdded = false) ->
		@productsList = [] if @productsList == null

		for newProducts in newProductsList
			newProducts = @prepareNewProducts newProducts, isManuallyAdded
			@addToList newProducts

	addToList: (newProducts) ->
		existingProduct = null

		for product in @productsList
			if product[0].product_id == newProducts[0].product_id
				existingProduct = product

				break

		if not existingProduct?
			@PurchaseOrderFormatService.convertQuantityTypes newProducts
			@productsList.unshift newProducts
			return

		# Add new variant only if it does not already exists
		for newVariant in newProducts
			exists = false

			for existingVariant in existingProduct
				if existingVariant.product_id == newVariant.product_id and existingVariant.product_variant_id == newVariant.product_variant_id
					exists = true
					break

			existingProduct.push(newVariant) if not exists

		virtualProduct = _.find existingProduct, {virtual: true}

		if virtualProduct?
			virtualProduct.min_quantity = @getColumnSum(existingProduct, 'min_quantity')
			virtualProduct.quantity = @getColumnSum(existingProduct, 'quantity')

		@PurchaseOrderFormatService.convertQuantityTypes existingProduct

	prepareNewProducts: (products, isManuallyAdded = false) ->
		newProducts = []
		hasMainProduct = _.find products, {product_variant_id: null}

		getNewProduct = (product) =>
			return angular.extend(
				{
					virtual: not hasMainProduct? and not product.product_variant_id?
					manual: isManuallyAdded
					selected: true
					average_per_day: null
					suggested_restock: 0
					restock: 0
					total_quantity: 0
					product_supplier_name: _.find(@suppliers, {id: product.product_supplier_id})?.name
					product_variant_supplier_name: _.find(@suppliers, {id: product.product_variant_supplier_id})?.name
				},
				product
			)

		for variant in products
			newProducts.push(getNewProduct(variant))

		if not hasMainProduct?
			newProducts.unshift @getVirtualProduct(newProducts, isManuallyAdded)

		@PurchaseOrderFormatService.convertQuantityTypes newProducts

		return newProducts
